<template>
  <transition name="sliderup-animation">
    <div
      v-show="isOpened"
      class="sliderup"
      @click="closeSliderUp"
    >
      <div class="sliderup-container" @click.stop>
        <div class="sliderup-title">
          <slot name="header" />
          <button class="btn btn--close" @click="closeSliderUp" />
        </div>
        <div class="sliderup-content slide-content">
          <slot name="body" />
        </div>
        <div class="sliderup-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    isOpened: { type: Boolean, default: false },
    isClosableFromOverlay: { type: Boolean, default: true },
  },
  /**
   * add no-scroll class on body when modal is opened,
   * in order to avoid scrolling issues
   */
  watch: {
    isOpened() {
      document.body.classList.toggle('no-scroll');
    },
  },
  methods: {
    /**
     * method triggered on overlay or button click.
     * trigger the close method of the parent
     */
    closeSliderUp() {
      this.$emit('close');
    },
  },
};
</script>
